import React, { Component, createRef } from 'react';
import AuthContext from '../AuthContext';
import { FacebookLogin } from '../components/Auth/FacebookLogin';
import { GoogleLogin } from '../components/Auth/GoogleLogin';
import { GATEWAY_URL } from '../utils';

export class Login extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.input_usr = createRef();
        this.input_pwd = createRef();
        this.register_name = createRef();
        this.register_email = createRef();
        this.register_pwd = createRef();

        this.state = {
            showRegister: false
        };
    }

    componentDidMount() {
        if (typeof this.context.validate === 'function') {
            this.context.validate();
        }
    }

    handleSignin = async () => {
        const email = this.input_usr.current.value;
        const password = this.input_pwd.current.value;

        if (!email || !password || email.length <= 4 || password.length <= 4) {
            alert("Invalid email or password");
            return;
        }

        try {
            const response = await fetch(GATEWAY_URL + "/auth/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include", // <-- send/receive HttpOnly cookies
                body: JSON.stringify({ email, password })
            });

            if (!response.ok) {
                const errData = await response.json();
                alert(errData?.message || "Login failed");
                return;
            }

            // Backend already set cookies, just fetch profile
            await this.context.login?.(); // populates AuthProvider state
            this.onHide();

        } catch (err) {
            console.error(err);
            alert("Login failed, please try again.");
        }
    }

    onHide = () => {
        this.context.toggleLoginModal();
    }

    handleRegister = async () => {
        const name = this.register_name.current.value;
        const email = this.register_email.current.value;
        const password = this.register_pwd.current.value;

        if (!name || !email || !password) {
            alert("Please fill all fields");
            return;
        }

        try {
            const response = await fetch(GATEWAY_URL + "/auth/register", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include", // optional, cookies may be set if backend wants
                body: JSON.stringify({ name, email, password })
            });

            const result = await response.json();

            if (response.ok) {
                alert("Registered successfully. You may now sign in.");
                this.setState({ showRegister: false });
            } else {
                alert(result.message || "Registration failed");
            }
        } catch (err) {
            console.error(err);
            alert("Registration failed, please try again.");
        }
    }

    render() {
        const { isChecked, show, isAuthenticated } = this.context;
        const { showRegister } = this.state;

        if (!isChecked) return null;
        if (!show) return null;
        if (isAuthenticated) return null;

        return (
            <div className="hk-auth-backdrop">
                <div className="hk-auth-card">
                    <div className="flex justify-between items-start mb-1">
                        <div className="flex items-center gap-2">
                            <span className="w-9 h-9 rounded-full bg-[#0f172a] flex items-center justify-center text-base shadow-lg">
                                ⚡
                            </span>
                            <span className="hk-display font-bold text-xl">Haki</span>
                        </div>
                        <button
                            className="w-8 h-8 rounded-full bg-[#f1f5f9] text-[#64748b] hover:bg-[#e2e8f0] transition"
                            onClick={this.onHide}
                        >
                            ✕
                        </button>
                    </div>
                    <h5 className="hk-display text-2xl font-bold mt-3">
                        {showRegister ? "Create your account" : "Welcome back"}
                    </h5>
                    <p className="text-sm text-[#64748b] mb-6">
                        {showRegister
                            ? "Free systems + free deployment credit."
                            : "Sign in to deploy and manage your systems."}
                    </p>

                    {showRegister ? (
                        <form onSubmit={(e) => e.preventDefault()} className="space-y-3">
                            <div>
                                <label className="hk-label">Full name</label>
                                <input
                                    type="text"
                                    ref={this.register_name}
                                    className="hk-input"
                                    placeholder="Ada Lovelace"
                                />
                            </div>
                            <div>
                                <label className="hk-label">Email address</label>
                                <input
                                    type="email"
                                    ref={this.register_email}
                                    className="hk-input"
                                    placeholder="you@example.com"
                                />
                            </div>
                            <div>
                                <label className="hk-label">Password</label>
                                <input
                                    type="password"
                                    ref={this.register_pwd}
                                    className="hk-input"
                                    placeholder="••••••••"
                                />
                            </div>
                            <button
                                onClick={this.handleRegister}
                                className="hk-btn hk-btn-primary w-full"
                            >
                                Create account
                            </button>
                            <div className="text-center">
                                <small className="text-[#64748b]">
                                    Already have an account?{" "}
                                    <button
                                        className="text-[#0f172a] font-bold hover:underline"
                                        onClick={() => this.setState({ showRegister: false })}
                                    >
                                        Sign in
                                    </button>
                                </small>
                            </div>
                        </form>
                    ) : (
                        <form onSubmit={(e) => e.preventDefault()} className="space-y-3">
                            <div>
                                <label className="hk-label">Email address</label>
                                <input
                                    type="email"
                                    ref={this.input_usr}
                                    className="hk-input"
                                    placeholder="you@example.com"
                                />
                            </div>
                            <div>
                                <label className="hk-label">Password</label>
                                <input
                                    type="password"
                                    ref={this.input_pwd}
                                    className="hk-input"
                                    placeholder="••••••••"
                                />
                            </div>
                            <button
                                onClick={this.handleSignin}
                                className="hk-btn hk-btn-dark w-full"
                            >
                                Sign in →
                            </button>
                            <div className="text-center">
                                <button
                                    className="text-[#0f172a] font-bold hover:underline mt-1 text-sm"
                                    onClick={() => this.setState({ showRegister: true })}
                                >
                                    Create an account
                                </button>
                            </div>
                        </form>
                    )}

                    <div className="mt-6 border-t border-[#e2e8f0] pt-4 flex flex-col gap-3 items-center">
                        <GoogleLogin
                            onLoginSuccess={async (data) => {
                                if (data.error == null) {
                                    await this.context.login?.();
                                    this.onHide();
                                } else {
                                    alert("Google login failed");
                                }
                            }}
                        />
                        <FacebookLogin
                            onLoginSuccess={async (data) => {
                                if (data.error == null) {
                                    await this.context.login?.();
                                    this.onHide();
                                } else {
                                    alert("Facebook login failed");
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
